import { httpV2 } from "../../apis/http"
import URL_API from "../../apis/urlApi"
import { handleGetTeamId } from "../helpers"
import { MemberPrivilegeListPayloadProps, MemberPrivilegeListResponseProps } from "./memberService.interface"

const memberService = {
  list: async function (body: MemberPrivilegeListPayloadProps) {
    try {
      const team = handleGetTeamId()
      const payload = {
        profile_id: team,
        ...body,
      }
      const response = await httpV2(true).post<MemberPrivilegeListResponseProps>(URL_API.MEMBER_PRIVILAGE_LIST, payload)
      return response.data
    } catch (error) {
      throw 'error get member privilege llist'
    }
  },
}

export default memberService